import { ref } from 'vue'

// The version-history drawer is mounted once in AuthenticatedLayout so the
// publish bar's change list and the command palette can both open it, even
// after they unmount themselves.
const isOpen = ref(false)

export const useVersionHistoryDrawer = () => {
  const open = () => {
    isOpen.value = true
  }

  const close = () => {
    isOpen.value = false
  }

  return { isOpen, open, close }
}
